module.exports = __webpack_public_path__ + "blackfeet.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackfeet.png
// module id = 851
// module chunks = 0